export default "__VITE_ASSET__20714dc3__"